class BuyEcoWiseCollectionSearch extends HTMLElement {
  connectedCallback() {
    this.input = this.querySelector('[data-collection-search-input]');
    this.clearButton = this.querySelector('[data-collection-search-clear]');
    this.status = this.querySelector('[data-collection-search-status]');
    this.grid = document.querySelector('#ResultsList');

    if (!this.input || !this.grid) return;

    this.defaultStatus = this.status?.textContent || '';
    this.input.addEventListener('input', () => this.filterProducts());
    this.input.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.clearSearch();
    });
    this.clearButton?.addEventListener('click', () => this.clearSearch());

    this.observer = new MutationObserver(() => this.filterProducts());
    this.observer.observe(this.grid, { childList: true, subtree: true });
  }

  disconnectedCallback() {
    this.observer?.disconnect();
  }

  get cards() {
    return [...this.grid.querySelectorAll('.product-grid__item[data-product-search]')];
  }

  clearSearch() {
    this.input.value = '';
    this.filterProducts();
    this.input.focus();
  }

  filterProducts() {
    const query = this.input.value.trim().toLocaleLowerCase();
    let visibleCount = 0;

    for (const card of this.cards) {
      const searchText = (card.dataset.productSearch || card.textContent || '').toLocaleLowerCase();
      const matches = query === '' || searchText.includes(query);
      card.hidden = !matches;
      if (matches) visibleCount += 1;
    }

    if (this.clearButton) this.clearButton.hidden = query === '';
    if (!this.status) return;

    if (query === '') {
      this.status.textContent = this.defaultStatus;
    } else if (visibleCount === 0) {
      this.status.textContent = `No displayed products match “${this.input.value.trim()}”. Press Enter to search the full store.`;
    } else {
      this.status.textContent = `${visibleCount} displayed ${visibleCount === 1 ? 'product' : 'products'} match your search. Press Enter to search the full store.`;
    }
  }
}

if (!customElements.get('buyecowise-collection-search')) {
  customElements.define('buyecowise-collection-search', BuyEcoWiseCollectionSearch);
}
